"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 8.7A5.7 5.7 0 0 1 8.7 3h6.6A5.7 5.7 0 0 1 21 8.7v6.6a5.7 5.7 0 0 1-5.7 5.7H8.7A5.7 5.7 0 0 1 3 15.3zm5.7-4.3a4.3 4.3 0 0 0-4.3 4.3v6.6a4.3 4.3 0 0 0 4.3 4.3h6.6a4.3 4.3 0 0 0 4.3-4.3V8.7a4.3 4.3 0 0 0-4.3-4.3z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.645 7.345a1.3 1.3 0 0 0-.254.025.7.7 0 1 1-.272-1.373 2.7 2.7 0 0 1 .526-.052h.42a.7.7 0 1 1 0 1.4zm2.236-.7a.7.7 0 0 1 .7-.7h.838a.7.7 0 1 1 0 1.4h-.838a.7.7 0 0 1-.7-.7m3.355 0a.7.7 0 0 1 .7-.7h.419q.27 0 .526.052a.7.7 0 0 1-.272 1.373 1.3 1.3 0 0 0-.254-.025h-.42a.7.7 0 0 1-.7-.7m-7.417.923a.7.7 0 0 1 .551.823 1.3 1.3 0 0 0-.025.254v.42a.7.7 0 0 1-1.4 0v-.42q0-.27.052-.526a.7.7 0 0 1 .822-.55m10.362 0a.7.7 0 0 1 .822.551q.052.256.052.526v.42a.7.7 0 1 1-1.4 0v-.42q0-.132-.025-.254a.7.7 0 0 1 .551-.823M6.645 10.881a.7.7 0 0 1 .7.7v.838a.7.7 0 0 1-1.4 0v-.838a.7.7 0 0 1 .7-.7m10.71 0a.7.7 0 0 1 .7.7v.838a.7.7 0 1 1-1.4 0v-.838a.7.7 0 0 1 .7-.7m-10.71 3.355a.7.7 0 0 1 .7.7v.419q0 .132.025.254a.7.7 0 0 1-1.373.272 2.7 2.7 0 0 1-.052-.526v-.42a.7.7 0 0 1 .7-.7m10.71 0a.7.7 0 0 1 .7.7v.419q0 .27-.052.526a.7.7 0 1 1-1.373-.272q.024-.122.025-.254v-.42a.7.7 0 0 1 .7-.7M7.568 17.18a.7.7 0 0 1 .823-.55q.122.023.254.024h.42a.7.7 0 1 1 0 1.4h-.42q-.27 0-.526-.052a.7.7 0 0 1-.55-.822m8.864 0a.7.7 0 0 1-.55.822q-.258.051-.527.052h-.42a.7.7 0 1 1 0-1.4h.42q.132 0 .254-.025a.7.7 0 0 1 .823.55m-5.551.174a.7.7 0 0 1 .7-.7h.838a.7.7 0 1 1 0 1.4h-.838a.7.7 0 0 1-.7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CheckboxValueBlankIcon24.js.map